// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uGfZ","placeholdersHeader":"styles_placeholdersHeader__1GNC0","editorStyle":"styles_editorStyle__1wUvF","placeholdersBox":"styles_placeholdersBox__1e15o"};